import { useSyncExternalStore } from 'react';
import { DEFAULT_THEME_MODE, readSystemThemeMode, SYSTEM_THEME_QUERY } from '@/utils/themeMode.utils';

function subscribe(onChange: () => void) {
  const query = window.matchMedia(SYSTEM_THEME_QUERY);
  if (typeof query.addEventListener === 'function') {
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }
  if (typeof query.addListener === 'function') {
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }
  return () => {};
}

/** Tracks device appearance, including changes while the app is open. */
export function useSystemThemeMode() {
  return useSyncExternalStore(subscribe, readSystemThemeMode, () => DEFAULT_THEME_MODE);
}
